/**
 * Types to staticData
 */
export const STATIC_DATA_CLEAR = '[STATIC_DATA] CLEAR';
export const STATIC_DATA_SET_DATA = '[STATIC_DATA] SET DATA';